import axios from 'axios'

const axiosOptions = {withCredentials: true}

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api/v1`
  })

export const getContract = (contractPermalink) => {
    return api.get(`/wizard/contract/${contractPermalink}`, axiosOptions)
}

export const getContractAndOVC = (contractPermalink, uniqid) => {
    return api.get(`/wizard/contract/${contractPermalink}/${uniqid}`, axiosOptions)
}

export const getCheckout = (contractPermalink, uniqid) => {
    return api.get(`/wizard/checkout/${contractPermalink}/${uniqid}`, axiosOptions)
}

export const saveInstance = (contractPermalink, instanceData, isAutosaved = false) => {
    return api.post(`/wizard/instance/${contractPermalink}${isAutosaved ? '?autosaved' : ''}`, instanceData, axiosOptions)
}

export const updateInstance = (contractPermalink, uniqd, instanceData) => {
    return api.put(`/wizard/instance/${contractPermalink}/${uniqd}`, instanceData, axiosOptions)
}

export const createOrder = (uniqid, orderData) => {
    return api.post(`/wizard/order/${uniqid}`, orderData, axiosOptions)
}

export const validateCoupon = (uniqid, couponCode) => {
    return api.post(`/wizard/order/coupon/validate`, {uniqid, couponCode}, axiosOptions)
}

export const getContractOrder = (uniqid) => {
    return api.get(`/form/orders/${uniqid}`, axiosOptions)
}

export const checkGeneratedFiles = (uniqid) => {
    return api.get(`/wizard/generation/check/${uniqid}`, axiosOptions)
}



// WEBPACK FOOTER //
// ./src/manager/apiManager.js